export const config = {
	apiKey: "AIzaSyD2_xDbmMwOL2hHk4WX2_swcDIn2Jbv7Q0",
	authDomain: "swipe-app-zuidbroek.firebaseapp.com",
	projectId: "swipe-app-zuidbroek",
	storageBucket: "swipe-app-zuidbroek.firebasestorage.app",
	messagingSenderId: "737638654475",
	appId: "1:737638654475:web:b3c8c9cabfa2994a6d9d0e",
};
